import { VerticalTimeline }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import TimelineElement from '../../components/timeline/TimelineElement';
import './timeline.scss';
import resumeData from '../../data/resume.json';
import { WorkOrSchoolProps } from '../../components/resume/interfaces';
import Pill from '../../components/pill/Pill';
import { getCSSVariable } from '../../helpers/styleHelper';
import { TimelineElementProps } from '../../components/timeline/interfaces';

function Timeline(props: any) {

  const timelineBlocks: WorkOrSchoolProps[][] = [
    resumeData.work.filter(record => record.institution === "Wizards of the Coast"),
    resumeData.work.filter(record => record.institution === "Sitecore"),
    resumeData.work.filter(record => record.institution === "L3 WESCAM"),
    resumeData.school
  ]

  return (
    <section id="timeline">
      <div className="timeline-container">
      <h2>My experience</h2>
        <VerticalTimeline lineColor={getCSSVariable("--foreground1")}>
          { 
            timelineBlocks.map((block: WorkOrSchoolProps[], index: number) => (
              generateTimelineBlock(block, index)
            ))
          }
        </VerticalTimeline>
      </div>
    </section>
  )
}

function generateTimelineBlock(block: WorkOrSchoolProps[], index: number) {
  const institutionCssClass = block[0].institution.replaceAll(' ', '-');
  const elementPosition = index % 2 == 0 ? 'left' : 'right';
  return (              
    <div className={`${institutionCssClass} sub-timeline`}>
      {
        block.map((record: WorkOrSchoolProps) => (
          <TimelineElement key={record.title} 
            element={generateTimelineElementProps(record, elementPosition)} />
        ))
      }
    </div>
    )
}

function generateTimelineElementProps(record: WorkOrSchoolProps, elementPosition: string): TimelineElementProps {
  return {
    elementPosition: elementPosition,
    date: (`${record.dateStarted}` + (record.dateEnded ? ` - ${record.dateEnded}` : '')),
    title: record.title,
    institution: record.institution,
    content: (record.skills.map(s => <Pill key={s} text={s}></Pill>)), 
    //icon: (<span className="fab fa-github-sqaure"></span>)
  };
}

export default Timeline;